import { createFeature, createReducer, on } from '@ngrx/store';

import { SetupPhase, SetupStep } from '@core/models';

import { SetupApiActions, SetupPageActions } from './setup.actions';

/** The authored Get Started checklist. */
export interface SetupState {
  readonly steps: SetupStep[];
  readonly phases: SetupPhase[];
  readonly loading: boolean;
  readonly error: string | null;
}

const initialState: SetupState = { steps: [], phases: [], loading: false, error: null };

export const setupFeature = createFeature({
  name: 'setup',
  reducer: createReducer(
    initialState,
    on(SetupPageActions.entered, (state) => ({ ...state, loading: true, error: null })),
    on(SetupApiActions.loadSuccess, (state, { steps, phases }) => ({ ...state, steps, phases, loading: false })),
    on(SetupApiActions.loadFailure, (state, { error }) => ({ ...state, loading: false, error })),
    // The whole list is replaced: an edit can change order as well as content.
    on(SetupPageActions.stepsChanged, (state, { steps }) => ({ ...state, steps })),
    on(SetupPageActions.phasesChanged, (state, { phases }) => ({ ...state, phases })),
  ),
});

export const { selectSteps, selectPhases, selectLoading } = setupFeature;
